import plant1 from './plant-1.svg';
import plant2 from './plant-2.svg';
import plant3 from './plant-3.svg';
import plant4 from './plant-4.svg';
import plant5 from './plant-5.svg';
import parrot from './parrot.svg';
import jaguar from './jaguar.svg';

const decorations = {
  plant1,
  plant2,
  plant3,
  plant4,
  plant5,
  jaguar,
  parrot,
};

export default decorations;
